import { FC } from 'react';

import DividendsDistributionModalHeader from './components/DividendsDistributionModalHeader';
import DividendsDistributionModalBody from './components/DividendsDistributionModalBody';
import DividendsDistributionModalFooter from './components/DividendsDistributionModalFooter';
import { useDividendsDistributionModal } from './context/DividendsDistributionModalContext';

import CustomLoading from '../../CustomLoading';
import '../Modals.scss';

const DividendsDistributionModal: FC = () => {
  const { data } = useDividendsDistributionModal();

  return (
    <>
      <DividendsDistributionModalHeader />
      <DividendsDistributionModalBody />
      <DividendsDistributionModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default DividendsDistributionModal;
